export const PAYMENT_TYPE_AMEX = 'amex';
export const PAYMENT_TYPE_VISA = 'visa';

export const SURCHARGE_TYPE_AMEX = 'AmexSurcharge';
